<template>
  <section v-show="showComponent">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- slot-scope="prop" -->
      <section slot="fleetChart">
        <Contract
          ref="contract"
          :chartData="otherFormData"
          :appointWay="5"
        />
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">指派车队提交参数</button>
  </section>
</template>

<script>
import { getSysTenantDef, getAccountInfo } from 'api/operate';
import Contract from '../components/contract';
export default {
  components: {
    Contract,
  },
  props: {
    showComponent: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      otherFormData: {
        tenantInfo: {},
        lineInfo: {},
      },
      baseForm: {
        form: [
          {
            label: '承运车队',
            value: 'toTenantName',
            type: 'el-autocomplete',
            valueKey: 'name',
            placeholder: '请输入承运车队',
            querySearchAsync: (queryString, cb) => {
              // cb 返回的是检索出来匹配的数组
              let resInfo = [];
              if (queryString && queryString.length) {
                // 如果修改了但是没选中新的，就清空相关的字段
                if (this.otherFormData.tenantInfo.name !== queryString) {
                  this.$refs.baseForm.setVal('acctName', '');
                  this.$refs.baseForm.setVal('acctNo', '');
                  this.$refs.baseForm.setVal('toTenantId', '');
                }
                getSysTenantDef({ name: queryString }).then((res) => {
                  if (res && res.items) {
                    resInfo = res.items;
                  }
                  cb(resInfo);
                });
              }
              cb(resInfo);
            },
            onSelect: (item) => {
              if (item.tenantId) {
                this.otherFormData.tenantInfo = item;
                this.getAccountInfo(item.tenantId);
              }
            },
          },
          {
            label: '承运人',
            value: 'acctName',
            type: 'input',
            readonly: true,
            placeholder: '承运人',
          },
          {
            label: '承运账号',
            value: 'acctNo',
            type: 'input',
            readonly: true,
            placeholder: '承运账号',
          },
          {
            label: '承运车队Id',
            value: 'toTenantId',
            type: 'input',
            readonly: true,
            hide: true,
          },
          {
            value: 'fleetChart',
            allCustom: true,
          },
        ],
        rules: {
          toTenantName: [
            { required: false, message: '请选择承运车队', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      // console.log('指派车队提交参数', this.sub());
    },
    setData (data) {
      if (data && data.lineInfo) {
        this.otherFormData.lineInfo = data.lineInfo;
      }
    },
    async getAccountInfo (tenantId) {
      const resAccInfo = await getAccountInfo({ tenantId });
      if (resAccInfo && resAccInfo.PRIVATE_0) {
        this.$refs.baseForm.setVal('acctName', resAccInfo.PRIVATE_0.acctName || '');
        this.$refs.baseForm.setVal('acctNo', resAccInfo.PRIVATE_0.acctNo || '');
        this.$refs.baseForm.setVal('toTenantId', tenantId || '');
      }
    },
    setBaseForm (data) {
      this.$refs.baseForm.setVal('acctName', data.linkman || '');
      this.$refs.baseForm.setVal('acctNo', data.loginAcct || '');
      this.$refs.baseForm.setVal('toTenantId', data.userId || '');
    },
    setCacheAndDetailData (data) {
      this.$refs.baseForm.setVal('acctName', data.acctName);
      this.$refs.baseForm.setVal('acctNo', data.acctNo);
      this.$refs.baseForm.setVal('toTenantId', data.toTenantId);
      this.$refs.baseForm.setVal('toTenantName', data.toTenantName);
      this.$nextTick(() => {
        if (this.$refs.contract) {
          this.$refs.contract.setCacheAndDetailData(data);
        }
      });
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        let contractFormData = null;
        if (this.$refs.contract) {
          contractFormData = await this.$refs.contract.sub() || {};
        }
        formData = {
          ...formData,
          ...this.otherFormData,
          ...contractFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
  },
  watch: {
    showComponent: {
      immediate: true,
      handler (newValue, oldValue) {
        this.setFormRuleAttr({
          rules: this.baseForm.rules,
          attr: 'required',
          value: newValue,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>
